import React, { useEffect, useState } from "react";
import Layout from "../../../app/Layout";
import HeaderContent from "../General/HeaderContent";
import Breadcrumb from "../General/Breadcrumb";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilePdf, faDownload, faEye, faTrash, faUpload,
  faFileInvoice, faCheckCircle, faClock, faExclamationTriangle,
  faSearch, faFilter, faCalendarAlt, faUserTie, faTimes,
  faTimesCircle, faQuestionCircle
} from "@fortawesome/free-solid-svg-icons";
import SpinnerLoading from "../../components/Spinners/SpinnerLoading";
import { updateStateModalLarge } from "../../../actions/modalActions";
import ModalBasicwithRedux from "../../../containers/ModalLargewhithRedux";
import FormularioSubidaBoletas from "./FormularioSubidaBoletas";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import { eliminarBoleta, listarBoletas, limpiarResultadoBoletas } from "../../../actions/boletasActions";

const MESES = [
  "", "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];

const ESTADO_CFG = {
  asignada:   { color: "#28a745", label: "Disponible",   icon: faCheckCircle },
  disponible: { color: "#28a745", label: "Disponible",   icon: faCheckCircle },
  sin_asignar:{ color: "#dc3545", label: "Sin asignar",  icon: faTimesCircle },
  revision:   { color: "#17a2b8", label: "En revisión",  icon: faExclamationTriangle },
  pendiente:  { color: "#fd7e14", label: "Pendiente",    icon: faClock },
};

const EstadoBadge = ({ estado, archivo }) => {
  const key = estado || (archivo ? "asignada" : "pendiente");
  const cfg = ESTADO_CFG[key] || ESTADO_CFG.pendiente;
  return (
    <span style={{
      fontSize: 12, fontWeight: 600, color: cfg.color,
      backgroundColor: `${cfg.color}18`, padding: "3px 10px", borderRadius: 20,
      display: "inline-flex", alignItems: "center", gap: 5
    }}>
      <FontAwesomeIcon icon={cfg.icon} style={{ fontSize: 11 }} />
      {cfg.label}
    </span>
  );
};

/* ── Panel de resultado de carga ── */
const ResultadoCarga = ({ resultado, onCerrar }) => {
  if (!resultado) return null;
  const { detectadas, asignadas, sin_asignar, erroneas, detalle } = resultado;

  return (
    <div className="box mb-3" style={{ border: "1px solid #e9ecef" }}>
      <div className="box-header d-flex align-items-center justify-content-between"
        style={{ padding: "12px 18px", backgroundColor: "#f8f9fa", borderBottom: "2px solid #e9ecef" }}>
        <span style={{ fontWeight: 700, fontSize: 15 }}>
          <FontAwesomeIcon icon={faUpload} className="mr-2 text-primary" />
          Resultado de la última carga
        </span>
        <button onClick={onCerrar} style={{ background: "none", border: "none", color: "#aaa", cursor: "pointer", fontSize: 16 }}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>
      <div className="box-body" style={{ padding: "16px 18px" }}>

        {/* Tarjetas estadísticas */}
        <div className="row mb-3">
          {[
            { label: "Detectadas",  val: detectadas,  color: "#17a2b8", icon: faFileInvoice },
            { label: "Asignadas",   val: asignadas,   color: "#28a745", icon: faCheckCircle },
            { label: "Sin asignar", val: sin_asignar, color: "#dc3545", icon: faTimesCircle },
            { label: "Con error",   val: erroneas,    color: "#fd7e14", icon: faExclamationTriangle },
          ].map((item, i) => (
            <div key={i} className="col-6 col-md-3 mb-2">
              <div style={{
                padding: "12px 14px", borderRadius: 10, backgroundColor: `${item.color}10`,
                borderLeft: `4px solid ${item.color}`
              }}>
                <div style={{ fontSize: 28, fontWeight: 700, color: item.color, lineHeight: 1 }}>{item.val}</div>
                <div style={{ fontSize: 12, fontWeight: 600, color: "#666", marginTop: 4 }}>
                  <FontAwesomeIcon icon={item.icon} className="mr-1" />{item.label}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Detalle por archivo */}
        {detalle && detalle.length > 0 && (
          <div style={{ maxHeight: 220, overflowY: "auto", border: "1px solid #e9ecef", borderRadius: 8 }}>
            <table className="table table-sm mb-0" style={{ fontSize: 13 }}>
              <thead style={{ backgroundColor: "#f8f9fa", position: "sticky", top: 0 }}>
                <tr>
                  <th style={{ padding: "8px 12px" }}>Archivo</th>
                  <th style={{ padding: "8px 12px", width: 100 }}>DNI</th>
                  <th style={{ padding: "8px 12px", width: 130 }}>Estado</th>
                  <th style={{ padding: "8px 12px" }}>Mensaje</th>
                </tr>
              </thead>
              <tbody>
                {detalle.map((d, i) => {
                  const cfg = ESTADO_CFG[d.estado] || ESTADO_CFG.pendiente;
                  return (
                    <tr key={i} style={{ borderBottom: "1px solid #f5f5f5" }}>
                      <td style={{ padding: "6px 12px", maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {d.archivo}
                      </td>
                      <td style={{ padding: "6px 12px", fontFamily: "monospace" }}>{d.dni || "—"}</td>
                      <td style={{ padding: "6px 12px" }}>
                        <span style={{
                          fontSize: 11, fontWeight: 600, color: cfg.color,
                          backgroundColor: `${cfg.color}15`, padding: "2px 8px", borderRadius: 20
                        }}>
                          {cfg.label}
                        </span>
                      </td>
                      <td style={{ padding: "6px 12px", color: "#777" }}>{d.mensaje || "—"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════════ */
const BoletasDePago = () => {
  const { boletas, loading, uploadResult } = useSelector(state => state.boletas);
  const { usuario } = useSelector(state => state.usuario);
  const dispatch = useDispatch();

  const now = new Date();
  const [filtroPeriodo, setFiltroPeriodo] = useState(now.getFullYear().toString());
  const [filtroMes,     setFiltroMes]     = useState("");
  const [filtroEstado,  setFiltroEstado]  = useState("");
  const [busqueda,      setBusqueda]      = useState("");
  const [modalPdf,      setModalPdf]      = useState(null);

  const esAdmin = usuario.id_tp_nivel_usuario === "1" || usuario.id_tp_nivel_usuario === "6";

  useEffect(() => {
    dispatch(listarBoletas(usuario));
  }, []);

  const boletasFiltradas = (boletas || []).filter(b => {
    const matchPeriodo = !filtroPeriodo || String(b.periodo) === filtroPeriodo;
    const matchMes     = !filtroMes     || String(b.mes)     === filtroMes;
    const matchEstado  = !filtroEstado  || (b.estado || "asignada") === filtroEstado;
    const matchBusq    = !busqueda      || (b.empleado || "").toLowerCase().includes(busqueda.toLowerCase());
    return matchPeriodo && matchMes && matchEstado && matchBusq;
  });

  const total       = boletasFiltradas.length;
  const disponibles = boletasFiltradas.filter(b => !b.estado || b.estado === "asignada").length;
  const sinAsignar  = boletasFiltradas.filter(b => b.estado === "sin_asignar").length;
  const pendientes  = boletasFiltradas.filter(b => b.estado === "pendiente").length;

  const anios = [];
  for (let a = 2024; a <= now.getFullYear() + 1; a++) anios.push(a.toString());

  const handleSubir = () => {
    dispatch(updateStateModalLarge(<FormularioSubidaBoletas />, "Cargar Boletas de Pago"));
  };

  const urlBoleta = (archivo) =>
    `${process.env.REACT_APP_API_URL}/files_inedi/boletas_trabajadores/firmadas/${archivo}`;

  return (
    <Layout>
      <HeaderContent title="Boletas de Pago" icon="group" />
      <Breadcrumb
        link={[
          { url: "/inicio", nombre: "Inicio", icon: "fas fa-home" },
          { url: "", nombre: "Boletas de Pago" },
        ]}
      />

      <ModalBasicwithRedux />

      {/* ── Botón cargar (solo admin/finanzas) ── */}
      {esAdmin && (
        <div className="d-flex justify-content-end mb-3">
          <Button variant="primary" onClick={handleSubir} style={{ borderRadius: 8, fontWeight: 600 }}>
            <FontAwesomeIcon icon={faUpload} className="mr-2" />
            Cargar Boletas
          </Button>
        </div>
      )}

      {/* ── Panel resultado de última carga ── */}
      {esAdmin && uploadResult && (
        <ResultadoCarga
          resultado={uploadResult}
          onCerrar={() => dispatch(limpiarResultadoBoletas())}
        />
      )}

      {/* ── Tarjetas resumen ── */}
      <div className="row mb-3">
        {[
          { label: "Total",        val: total,       color: "#17a2b8", sub: "periodo seleccionado",  icon: faFileInvoice },
          { label: "Disponibles",  val: disponibles,  color: "#28a745", sub: "listas para descarga",  icon: faCheckCircle },
          { label: "Sin asignar",  val: sinAsignar,   color: "#dc3545", sub: "requieren revisión",     icon: faTimesCircle },
          { label: "Pendientes",   val: pendientes,   color: "#fd7e14", sub: "aún no disponibles",     icon: faClock },
        ].map((item, i) => (
          <div key={i} className="col-md-3 mb-2">
            <div className="box p-3" style={{ borderTop: `4px solid ${item.color}` }}>
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <div style={{ fontSize: 13, color: "#888", fontWeight: 600, textTransform: "uppercase" }}>{item.label}</div>
                  <div style={{ fontSize: 34, fontWeight: 700, color: item.color, lineHeight: 1.1 }}>{item.val}</div>
                  <div style={{ fontSize: 12, color: "#aaa" }}>{item.sub}</div>
                </div>
                <div style={{ width: 46, height: 46, borderRadius: 10, backgroundColor: `${item.color}18`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <FontAwesomeIcon icon={item.icon} style={{ color: item.color, fontSize: 20 }} />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* ── Filtros ── */}
      <div className="box p-3 mb-3">
        <div className="row align-items-end">
          <div className="col-md-2 mb-2">
            <label style={{ fontSize: 13, fontWeight: 600, color: "#555", marginBottom: 4 }}>
              <FontAwesomeIcon icon={faCalendarAlt} className="mr-1 text-muted" />Periodo
            </label>
            <select className="form-control form-control-sm" value={filtroPeriodo} onChange={e => setFiltroPeriodo(e.target.value)}>
              <option value="">Todos los años</option>
              {anios.map(a => <option key={a} value={a}>{a}</option>)}
            </select>
          </div>
          <div className="col-md-2 mb-2">
            <label style={{ fontSize: 13, fontWeight: 600, color: "#555", marginBottom: 4 }}>
              <FontAwesomeIcon icon={faFilter} className="mr-1 text-muted" />Mes
            </label>
            <select className="form-control form-control-sm" value={filtroMes} onChange={e => setFiltroMes(e.target.value)}>
              <option value="">Todos</option>
              {MESES.slice(1).map((m, i) => <option key={i+1} value={String(i+1)}>{m}</option>)}
            </select>
          </div>
          <div className="col-md-2 mb-2">
            <label style={{ fontSize: 13, fontWeight: 600, color: "#555", marginBottom: 4 }}>
              <FontAwesomeIcon icon={faQuestionCircle} className="mr-1 text-muted" />Estado
            </label>
            <select className="form-control form-control-sm" value={filtroEstado} onChange={e => setFiltroEstado(e.target.value)}>
              <option value="">Todos</option>
              <option value="asignada">Disponible</option>
              <option value="sin_asignar">Sin asignar</option>
              <option value="revision">En revisión</option>
            </select>
          </div>
          {esAdmin && (
            <div className="col-md-4 mb-2">
              <label style={{ fontSize: 13, fontWeight: 600, color: "#555", marginBottom: 4 }}>
                <FontAwesomeIcon icon={faSearch} className="mr-1 text-muted" />Buscar trabajador
              </label>
              <input
                className="form-control form-control-sm"
                placeholder="Nombre del trabajador..."
                value={busqueda}
                onChange={e => setBusqueda(e.target.value)}
              />
            </div>
          )}
        </div>
      </div>

      {/* ── Tabla ── */}
      <SpinnerLoading loading={loading}>
        <div className="box">
          <div className="box-header with-border d-flex align-items-center justify-content-between" style={{ padding: "14px 18px" }}>
            <h5 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: "#434343" }}>
              <FontAwesomeIcon icon={faFilePdf} className="mr-2 text-danger" />
              {esAdmin ? "Todas las Boletas de Pago" : "Mis Boletas de Pago"}
            </h5>
            <span style={{ fontSize: 13, color: "#888" }}>{total} registro(s)</span>
          </div>
          <div className="box-body p-0">
            {boletasFiltradas.length === 0 ? (
              <div className="text-center py-5" style={{ color: "#aaa" }}>
                <FontAwesomeIcon icon={faFileInvoice} style={{ fontSize: 40, display: "block", margin: "0 auto 12px" }} />
                <p style={{ fontSize: 15, fontWeight: 600 }}>No hay boletas para los filtros seleccionados</p>
                {esAdmin && <p style={{ fontSize: 13 }}>Usa el botón "Cargar Boletas" para subir nuevas boletas</p>}
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table mb-0" style={{ fontSize: 14 }}>
                  <thead style={{ backgroundColor: "#f8f9fa" }}>
                    <tr style={{ fontSize: 13, fontWeight: 700, color: "#555", borderBottom: "2px solid #e9ecef" }}>
                      <th style={{ padding: "12px 16px", width: 44 }}>#</th>
                      <th style={{ padding: "12px 16px" }}>Periodo</th>
                      <th style={{ padding: "12px 16px" }}>Mes</th>
                      <th style={{ padding: "12px 16px" }}>Fecha de carga</th>
                      {esAdmin && (
                        <th style={{ padding: "12px 16px" }}>
                          <FontAwesomeIcon icon={faUserTie} className="mr-1" />Trabajador
                        </th>
                      )}
                      <th style={{ padding: "12px 16px", textAlign: "center" }}>Estado</th>
                      <th style={{ padding: "12px 16px", textAlign: "center" }}>Documento</th>
                      {esAdmin && <th style={{ padding: "12px 16px", textAlign: "center" }}>Eliminar</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {boletasFiltradas.map((b, i) => (
                      <tr key={b.id_registro} style={{ borderBottom: "1px solid #f0f0f0" }}>
                        <td style={{ padding: "12px 16px", color: "#aaa", fontSize: 13 }}>{i + 1}</td>
                        <td style={{ padding: "12px 16px", fontWeight: 600 }}>{b.periodo}</td>
                        <td style={{ padding: "12px 16px" }}>
                          <span style={{ backgroundColor: "#f0f4ff", color: "#4a6cf7", padding: "2px 10px", borderRadius: 12, fontSize: 13, fontWeight: 600 }}>
                            {MESES[parseInt(b.mes)] || b.mes}
                          </span>
                        </td>
                        <td style={{ padding: "12px 16px", color: "#666", fontSize: 13 }}>
                          {b.fecha_registro || "—"}
                        </td>
                        {esAdmin && (
                          <td style={{ padding: "12px 16px", fontWeight: 500 }}>{b.empleado || "—"}</td>
                        )}
                        <td style={{ padding: "12px 16px", textAlign: "center" }}>
                          <EstadoBadge estado={b.estado} archivo={b.archivo} />
                        </td>
                        <td style={{ padding: "12px 16px", textAlign: "center" }}>
                          {b.archivo && b.estado !== "sin_asignar" ? (
                            <div className="d-flex justify-content-center" style={{ gap: 6 }}>
                              <button
                                title="Ver boleta"
                                onClick={() => setModalPdf(urlBoleta(b.archivo))}
                                style={{ backgroundColor: "#17a2b818", color: "#17a2b8", border: "none", borderRadius: 6, padding: "4px 10px", cursor: "pointer" }}
                              >
                                <FontAwesomeIcon icon={faEye} />
                              </button>
                              <a
                                href={urlBoleta(b.archivo)}
                                target="_blank"
                                rel="noreferrer"
                                download
                                title="Descargar"
                                style={{ backgroundColor: "#28a74518", color: "#28a745", border: "none", borderRadius: 6, padding: "4px 10px", textDecoration: "none" }}
                              >
                                <FontAwesomeIcon icon={faDownload} />
                              </a>
                            </div>
                          ) : (
                            <span style={{ fontSize: 12, color: b.estado === "sin_asignar" ? "#dc3545" : "#bbb" }}>
                              {b.estado === "sin_asignar" ? "En revisión" : "—"}
                            </span>
                          )}
                        </td>
                        {esAdmin && (
                          <td style={{ padding: "12px 16px", textAlign: "center" }}>
                            <button
                              title="Eliminar"
                              onClick={() => dispatch(eliminarBoleta(b.id_registro))}
                              style={{ backgroundColor: "#dc354518", color: "#dc3545", border: "none", borderRadius: 6, padding: "4px 10px", cursor: "pointer" }}
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </SpinnerLoading>

      {/* ── Modal previsualización PDF ── */}
      <Modal show={!!modalPdf} onHide={() => setModalPdf(null)} size="xl" centered>
        <Modal.Header closeButton style={{ borderBottom: "2px solid #e9ecef" }}>
          <Modal.Title style={{ fontSize: 15, fontWeight: 700 }}>
            <FontAwesomeIcon icon={faFilePdf} className="mr-2 text-danger" />
            Boleta de Pago
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: 0, height: "75vh" }}>
          {modalPdf && (
            <iframe
              src={modalPdf}
              title="Boleta de Pago"
              width="100%"
              height="100%"
              style={{ border: "none" }}
            />
          )}
        </Modal.Body>
        <Modal.Footer style={{ padding: "8px 16px" }}>
          <a href={modalPdf} download target="_blank" rel="noreferrer" className="btn btn-success btn-sm">
            <FontAwesomeIcon icon={faDownload} className="mr-1" />Descargar
          </a>
          <Button variant="secondary" size="sm" onClick={() => setModalPdf(null)}>Cerrar</Button>
        </Modal.Footer>
      </Modal>
    </Layout>
  );
};

export default BoletasDePago;
